import { API_BASE_URL } from '../config'

export interface ExamCreatePayload {
  subject: string
  group_id: string
  start_time?: string | null
  end_time?: string | null
  examination_time?: number | null
  is_supervised?: boolean
}

export interface GroupData {
  id: string
  name: string
  namespace_id: string
}

export interface ExamResponse {
  id: string
  subject: string
  namespace_id: string
  start_time: string | null
  ending_time: string | null
  examination_time: number | null
  is_supervised: boolean
  is_active: boolean
}

export class ExamService {
  static async getAllExams(): Promise<ExamResponse[]> {
    const res = await fetch(`${API_BASE_URL}/api/exams/`, { credentials: 'include' })
    if (!res.ok) {
      throw new Error('Failed to load exams')
    }
    return res.json()
  }

  static async createExam(payload: ExamCreatePayload): Promise<unknown> {
    const res = await fetch(`${API_BASE_URL}/api/exams/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'include',
    })
    if (!res.ok) {
      throw new Error('Failed to create exam')
    }
    return res.json()
  }

  static async getInstructorGroups(): Promise<GroupData[]> {
    const res = await fetch(`${API_BASE_URL}/api/groups/instructor-groups`, {
      credentials: 'include',
    })
    if (!res.ok) {
      throw new Error('Failed to fetch instructor groups')
    }
    return res.json()
  }
}
